import { render, staticRenderFns } from "./move_essay_modal.vue?vue&type=template&id=5ac2d5b3&"
import script from "./move_essay_modal.vue?vue&type=script&lang=js&"
export * from "./move_essay_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports